// Shopify stock allocation: cart additions never consume stock.
for (const widget of document.querySelectorAll('[data-nc-stock-widget]')) {
  if (widget.dataset.ncStockReady) continue;
  const root = widget.closest('[data-nc-product]');
  const data = document.querySelector('[data-nc-stock-data="' + widget.dataset.ncStockSection + '"]');
  if (!root || !data) continue;
  let inventory = JSON.parse(data.textContent);
  const ids = new Set(inventory.map(v => String(v.id)));
  const label = widget.querySelector('[data-nc-stock-label]');
  const detail = widget.querySelector('[data-nc-stock-detail]');
  const refreshButton = widget.querySelector('[data-nc-stock-refresh]');
  const liveLabel = widget.querySelector('[data-nc-stock-live-label]');
  let controller, lastCheck = 0, timer;
  const setText = (el, text) => { if (el.textContent !== text) el.textContent = text; };
  function refresh() {
    const selectedId = root.querySelector('[data-nc-variant-id]')?.value;
    const stock = inventory.find(v => String(v.id) === String(selectedId));
    if (!stock) return;
    root.dataset.ncTheme = /vert/i.test(stock.title) ? 'vert' : 'rose';
    setText(label, stock.tracked ? `${stock.quantity}/100 restants` : '100 exemplaires par taille et couleur');
    setText(detail, stock.title + (stock.available ? '' : ' · Épuisé')); 
  }
  function schedule() {
    clearTimeout(timer);
    if (document.visibilityState === 'visible' && root.isConnected) timer = setTimeout(poll, 30000);
  }
  async function poll() {
    if (controller || document.visibilityState !== 'visible' || !root.isConnected) return;
    controller = new AbortController();
    widget.dataset.ncStockState = 'loading';
    if (refreshButton) { refreshButton.disabled = true; refreshButton.setAttribute('aria-busy', 'true'); }
    const timeout = setTimeout(() => controller?.abort(), 8000);
    try {
      const url = new URL(widget.dataset.ncStockUrl, location.origin);
      url.searchParams.set('section_id', 'nocroute-inventory-feed');
      url.searchParams.set('_nc_stock', String(Date.now()));
      const response = await fetch(url, {cache:'no-store', credentials:'same-origin', signal:controller.signal});
      if (!response.ok) throw new Error('Inventory unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const payload = JSON.parse(html.querySelector('[data-nc-stock-feed]')?.textContent || 'null');
      if (String(payload?.product_id) !== widget.dataset.ncStockProduct || payload?.quota !== 100 || !Array.isArray(payload.variants) || payload.variants.length !== ids.size) throw new Error('Invalid inventory');
      const seen = new Set();
      for (const v of payload.variants) {
        if (!ids.has(String(v.id)) || seen.has(String(v.id)) || !Number.isInteger(v.quantity) || v.quantity < 0 || typeof v.tracked !== 'boolean' || typeof v.available !== 'boolean' || typeof v.title !== 'string') throw new Error('Invalid variant');
        seen.add(String(v.id));
      }
      inventory = payload.variants;
      lastCheck = Date.now();
      widget.dataset.ncStockCheckedAt = String(lastCheck);
      widget.dataset.ncStockState = 'ready';
      if (liveLabel) setText(liveLabel, 'Stock en direct');
      if (refreshButton) refreshButton.title = 'Vérifié à ' + new Date(lastCheck).toLocaleTimeString('fr-FR') + ' · actualisation toutes les 30 secondes';
      refresh();
      root.dispatchEvent(new CustomEvent('nocroute:inventory', {detail:payload}));
    } catch {
      // Keep the last verified quantities on temporary network failure.
      widget.dataset.ncStockState = 'stale';
      if (liveLabel) setText(liveLabel, 'Stock enregistré');
      if (refreshButton) refreshButton.title = 'Actualisation indisponible : dernier stock vérifié conservé. Réessayer.';
    } finally {
      clearTimeout(timeout);
      controller = undefined;
      if (refreshButton) { refreshButton.disabled = false; refreshButton.removeAttribute('aria-busy'); }
      schedule();
    }
  }
  function resume() { if (document.visibilityState === 'visible') poll(); else clearTimeout(timer); }
  root.addEventListener('change', () => { refresh(); if (Date.now() - lastCheck > 15000) poll(); });
  document.addEventListener('visibilitychange', resume);
  window.addEventListener('focus', resume);
  window.addEventListener('pagehide', () => { clearTimeout(timer); controller?.abort(); });
  window.addEventListener('pageshow', resume);
  refreshButton?.addEventListener('click', poll);
  widget.dataset.ncStockReady = 'true';
  refresh();
  poll();
}
